import countries from 'i18n-iso-countries'

export const isValidAlpha3CountryCode = (countryCode: string): countryCode is countries.Alpha3Code =>
  countries.isValid(countryCode)

export const getCountryFromAlpha3 = (countryCode: countries.Alpha3Code) => countries.getName(countryCode, 'en')
